export const TOKEN_MODAL = 'TOKEN'
export const DETAIL_MODAL = 'DETAILS'
export const TRANSFER_MODAL = 'TRANSFER'
export const ADD_TOKEN_MODAL = 'ADDTOKEN'
